import  { FC, useState } from "react"
import EventAddPhotoComponent from "@pages/makeEvent/steps-components/eventAddPhoto-component"
import EventDescriptionComponent from "@pages/makeEvent/steps-components/eventDescription-component"
import { PhotoAndDescriptionTabPanelProps } from '@/pages/eventEditing/components/types'
import extractPhotoName from '@pages/eventEditing/utils/extractPhotoNameForDeletion.ts'


const PhotoAndDescriptionTabPanel: FC<PhotoAndDescriptionTabPanelProps> = ({ formik, initialPhoto }) => {
	const [photo, setPhoto] = useState<Array<string>>(initialPhoto)

	const addPhoto = (imgArrBuf: string, imgDataUrl: string, pos: number) => {
    const updatedPhoto = [...photo]
    updatedPhoto[pos] = imgDataUrl
    setPhoto(() => updatedPhoto)
    // Новое фото — передаём массив байтов для повторной загрузки на бэкенд.
    // Пустая строка означает удаление (обрабатывается ниже).
    // Существующее имя файла (не массив байтов) не перезаписываем — бэкенд его знает.
    if (imgArrBuf !== '' || imgDataUrl !== '') {
      formik.setFieldValue(`avatars_for_adding[${pos}]`, imgArrBuf)
    }

		//if no data - add this photo to array for deletion
		if (imgArrBuf === '' && imgDataUrl=== '') {
			formik.setFieldValue(`avatars_for_deleting[${pos}]`, extractPhotoName(initialPhoto[pos]))
		}
  }

	return (
		<div style={{display: 'flex', flexDirection: 'column'}}>
			<EventAddPhotoComponent formik={formik} addPhoto={addPhoto} photo={photo} setHasValidPhoto={() => {}} />
			<EventDescriptionComponent formik={formik} setValidDescription={() => {}}/>
		</div>
	)
}

export default PhotoAndDescriptionTabPanel